import React from 'react';
import { motion } from 'framer-motion';
import { PauseCircle, Wind, Anchor } from 'lucide-react';
export function SolutionSection() {
  const steps = [{
    id: 1,
    name: 'Regulate',
    time: '2 mins',
    desc: "Interrupt the stress loop quickly. Physical switches that tell your brain 'we are safe now' even if the email just came in.",
    icon: <PauseCircle className="w-6 h-6 text-teal-600" data-id="element-145" />,
    color: 'bg-teal-50 border-teal-100'
  }, {
    id: 2,
    name: 'Release',
    time: '5 mins',
    desc: 'Get stored tension out of your body so it stops recycling. Simple movements to complete the stress cycle.',
    icon: <Wind className="w-6 h-6 text-indigo-600" data-id="element-146" />,
    color: 'bg-indigo-50 border-indigo-100'
  }, {
    id: 3,
    name: 'Rebuild',
    time: '5 mins',
    desc: 'Train a calm baseline. Short, potent practices that widen your window of tolerance for the next day.',
    icon: <Anchor className="w-6 h-6 text-amber-600" data-id="element-147" />,
    color: 'bg-amber-50 border-amber-100'
  }];
  return <section className="py-24 px-6 bg-[#faf9f7]" data-id="element-148">
      <div className="max-w-5xl mx-auto" data-id="element-149">
        <div className="text-center mb-16" data-id="element-150">
          <span className="text-teal-700 font-semibold tracking-wider uppercase text-sm" data-id="element-151">
            The Unique Mechanism
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mt-3 mb-6" data-id="element-152">
            The R³ Protocol
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-153">
            Most people try to "rebuild" first with affirmations and habits. But
            if your system is in threat mode, that won't stick. Order matters.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 relative" data-id="element-154">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-slate-200 -z-10" data-id="element-155" />

          {steps.map((step, idx) => <motion.div key={step.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.2
        }} className={`relative p-8 rounded-2xl border ${step.color} h-full flex flex-col`} data-id="element-156">
              <div className="w-12 h-12 bg-white rounded-full shadow-sm flex items-center justify-center mb-6 mx-auto md:mx-0 z-10" data-id="element-157">
                {step.icon}
              </div>

              <div className="flex items-baseline gap-3 mb-3" data-id="element-158">
                <h3 className="text-xl font-bold text-slate-900" data-id="element-159">
                  {step.name}
                </h3>
                <span className="text-sm font-medium px-2 py-1 bg-white rounded-md text-slate-500 shadow-sm" data-id="element-160">
                  {step.time}
                </span>
              </div>

              <p className="text-slate-600 leading-relaxed" data-id="element-161">{step.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="mt-12 p-6 bg-white rounded-xl border border-slate-200 shadow-sm text-center max-w-2xl mx-auto" data-id="element-162">
          <p className="font-medium text-slate-800" data-id="element-163">
            <span className="text-teal-600 font-bold" data-id="element-164">+ Plus:</span> A daily
            tracker to see it working and a relapse plan for when life gets
            messy.
          </p>
        </motion.div>
      </div>
    </section>;
}